import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { AppointmentReviewStatus, useData } from '@virtual-care/ui';

import Header from '../../components/header/header';

export default function AppointmentReviewSubmitted() {
  const { t } = useTranslation();
  const { reservationId } = useParams<{ reservationId: string }>();
  const { data: reservation } = useData('GET /reservations/{id}', {
    id: reservationId!,
  });
  return (
    <>
      <Header
        title={
          <h1 className="text-xl font-bold">
            {t('appointments.reviewSubmitted.headerPrefix', {
              number: reservation?.reservationNumber ?? '',
            })}
          </h1>
        }
      />

      <AppointmentReviewStatus>
        <h2 className="text-center text-3xl font-bold text-gray-900">
          {t('appointments.reviewSubmitted.successTitle')}
        </h2>
        <p className="max-w-md text-center text-base text-gray-500">
          {t('appointments.reviewSubmitted.successDescription')}
        </p>
      </AppointmentReviewStatus>
    </>
  );
}
